export default "__VITE_ASSET__DEHuFShl__"